
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.36 12c3.989 0 7.458-2.224 9.235-5.5A10.498 10.498 0 0010.36 1a10.498 10.498 0 00-9.235 5.5A10.498 10.498 0 0010.36 12zm0-12a11.5 11.5 0 0110.36 6.5A11.5 11.5 0 0110.36 13 11.5 11.5 0 010 6.5 11.5 11.5 0 0110.36 0zm0 2a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm0 1a3.5 3.5 0 100 7 3.5 3.5 0 000-7z","fill":"#000"}})])
          )
        }
      }
    